import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const KIND = { screenshot: "സ്ക്രീൻഷോട്ട് ശ്രമം", screen_record: "സ്ക്രീൻ റെക്കോർഡിംഗ് ശ്രമം", app_hidden: "കോളിനിടെ ആപ്പ് പിന്നിലേക്ക്", devtools: "DevTools ശ്രമം", print: "പ്രിന്റ് ശ്രമം", multi_touch: "മൾട്ടി-ഫിംഗർ ടച്ച് (സ്ക്രീൻ ഓഫ്)", privacy_violation: "Privacy Violation — വ്യക്തിഗത വിവരം പങ്കിടൽ" };

export const logSecurityEvent = (kind, context) => api.post("/security/events", { kind, context }).catch(() => null);

export const SecurityLog = ({ refreshKey }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/security/events").then((r) => setList(r.data)).catch(() => null); }, [refreshKey]);
  return (
    <div data-testid="security-log-box" className="card rounded-2xl p-4 space-y-2">
      <p className="text-sm font-bold flex items-center gap-2"><ShieldAlert size={15} className="text-[var(--crimson)]" /> സെക്യൂരിറ്റി അലർട്ട് ലോഗ്</p>
      <p className="text-[11px] text-[var(--muted-text)]">സ്ക്രീൻഷോട്ട് / സ്ക്രീൻ റെക്കോർഡിംഗ് ശ്രമങ്ങൾ തീയതി-സമയത്തോടെ ഇവിടെ രേഖപ്പെടുത്തും. ഈ ലോഗ് അഡ്മിനും കാണാം.</p>
      <ul className="divide-y divide-[var(--line)] max-h-56 overflow-y-auto">
        {list.length === 0 && <li className="py-2 text-xs text-emerald-600">✔ അലർട്ടുകൾ ഇല്ല</li>}
        {list.map((e) => <li key={e.id} data-testid={`security-event-${e.id}`} className="py-2 flex items-center justify-between text-xs"><span className="font-semibold text-[var(--crimson)]">{KIND[e.kind] || e.kind}{e.context ? <span className="text-[var(--muted-text)] font-normal"> · {e.context}</span> : null}</span><span className="font-num text-[var(--muted-text)]">{new Date(e.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "medium" })}</span></li>)}
      </ul>
    </div>
  );
};
